

import {Component, OnInit} from '@angular/core';
import {DataStorageService} from '../../shared/data-storage.service';
import {AdminDashboardService} from '../admin-dashboard/admin-dashboard.service';
import {NGXLogger} from 'ngx-logger';
import {
    BillerPerformance, TopBiller,
  TopBillerResp,
  NumberOfVisitors, InputOfVisitors, AssistedPerformance
} from '../admin-dashboard/view-admin-dashboard';

import {
  ViewAssistedDashboard,ViewAssistedDashboardResponse, ViewAssistedTxnsDashboardGraphDataResponse,
  AssistedPaymentKeyperFormanceIndicatorView, AssistedTxnsStaticsView,AssistedTxnsRegBillerView,
  AssistedPaymentSuccessRateView,AssistedPaymentTxnsAmountView,AssistedPaymentTxnsAmountViewResp,
} from "./view-assisted-dashboard";

import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {LeftMenu} from '../../shared/leftmenu/LeftMenu';
import {LoaderService} from '../../shared/loader/loader.service';
import {TranslateService} from '../../../../node_modules/@ngx-translate/core';
import {Subscription} from '../../../../node_modules/rxjs';
import {AssistedDashboardService} from "./assisted-dashboard.service";
import {Ekpayuser} from "../../user/user";


@Component({
  selector: 'app-assisted-dashboard',
   templateUrl: './assisted-dashboard.component.html',
   styleUrls: ['./assisted-dashboard.component.css']
})
export class AssistedDashboardComponent implements OnInit {

  viewAssistedDashboardResponse: ViewAssistedDashboardResponse;
  viewAssistedTxnsDashboardGraphDataResponse: ViewAssistedTxnsDashboardGraphDataResponse;
  viewAssistedDashboard: ViewAssistedDashboard;
  assistedPaymentKeyperFormanceIndicatorView: AssistedPaymentKeyperFormanceIndicatorView;
  assistedTxnsStaticsView: AssistedTxnsStaticsView;
  assistedTxnsRegBillerView: AssistedTxnsRegBillerView;
  billerPerformance: BillerPerformance;
  assistedPerformance: AssistedPerformance;
  topBillerResp: TopBillerResp;
  assistedPaymentSuccessRateView: AssistedPaymentSuccessRateView;
  assistedPaymentTxnsAmountViewResp: AssistedPaymentTxnsAmountViewResp;
  assistedPaymentTxnsAmountView: AssistedPaymentTxnsAmountView;
  inputOfVisitors: InputOfVisitors;
  numberOfVisitors: NumberOfVisitors;
  loginUser: Ekpayuser;

  public barChartData: any[];
  public barChartLabels: string[];
  public pieChartData: number[];
  public barChart2Data: any[];
  public barChart2Labels: string[];
  public barChartAssistedData: any[];
  public barChartAssistedLabels: string[];
  public hollowLineChartData: Array<any>;
  public hollowLineChartLabels: Array<any>;
  public LinePIChartData: Array<any>;
  public LinePIChartLabels: Array<any>;
  public linePISFChartData: Array<any>;
  public linePISFChartLabels: Array<any>;
  public lineSFChartLabels: Array<any>;
  public lineSFChartData: Array<any>;
  public lineChartData: Array<any>;
  public lineChartLabels: Array<any>;
  color: string = '#';

  loaderOff: number;
  numberOfTrans = 0;
  transactionAmount = 0;
  textHeading: string;

  activeAllFlag: boolean = false;
  activeYearFlag: boolean = false;
  activeLastYearFlag: boolean = false;
  activeMonthFlag: boolean = false;
  activeWeekFlag: boolean = false;
  activeTodayFlag: boolean = false;

  customFlag: boolean = false;

  isDataRefresh: boolean = false;
  isRecentTransaction: boolean = false;
  isTopBillerAvail: boolean = false;

  isGetTxsnUpdate: Boolean = false;
  isTxsnReportUpdate: boolean = false;
  isKeyPerUpdate: boolean = false;
  isTxsnStaticsUpdate: boolean = false;
  isRegCitizenUpdate: boolean = false;
  isRegBillerUpdate: boolean = false;
  isTopRecordUpdate: boolean = false;
  isPITxsnUpdate: boolean = false;
  isPMTxsnUpdate: boolean = false;
  isPISuccFailUpdate: boolean = false;
  isPMSuccFailUpdate: boolean = false;
  idBillerPerUpdate: boolean = false;
  isAssistedUpdate: boolean = false;
  isVisitorUpdate: boolean = false;
  subscription: Subscription;
  lang: string;
  merchantId: string;

  constructor(private dataStorageService: DataStorageService,
              private serviceAdmin: AdminDashboardService,
              private logger: NGXLogger,
              private router: Router,
              private pipe: DatePipe, private leftMenu: LeftMenu,
              private loaderService: LoaderService,
              private readonly translate: TranslateService,
              private serviceAssisted: AssistedDashboardService
  ) {
  }

  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.translate.use(this.lang);
    })
    window.scroll(0, 0);
    this.dataStorageService.setTabData("tabAdminDashboard");
    this.dataStorageService.setTabData("tabAssistedDashboard");

    // this.viewAssistedDashboardResponse = new ViewAssistedDashboardResponse();
    // this.viewAssistedTxnsDashboardGraphDataResponse = new ViewAssistedTxnsDashboardGraphDataResponse();
    // this.assistedPaymentKeyperFormanceIndicatorView = new AssistedPaymentKeyperFormanceIndicatorView();
    // this.assistedTxnsRegBillerView = new AssistedTxnsRegBillerView();
    // this.billerPerformance = new BillerPerformance();
    // this.assistedTxnsStaticsView = new AssistedTxnsStaticsView();
    // this.topBillerResp = new TopBillerResp();
    // this.assistedPaymentSuccessRateView = new AssistedPaymentSuccessRateView();
    // this.viewAssistedDashboard = new ViewAssistedDashboard();
    // this.assistedPaymentTxnsAmountViewResp = new AssistedPaymentTxnsAmountViewResp();
    // this.assistedPaymentTxnsAmountView = new AssistedPaymentTxnsAmountView();
    this.inputOfVisitors = new InputOfVisitors();
    this.viewAssistedDashboard.mode = "web";
    this.loginUser = JSON.parse(localStorage.getItem('sessuser'));
    this.getTodayWeekMonthYearDate('today');
  }

  getTodayWeekMonthYearDate(valTime) {
    this.transactionAmount = 0;
    this.numberOfTrans = 0;
    this.isDataRefresh = false;
    let todayFrmtdDate = this.pipe.transform(new Date(), 'yyyy-MM-dd');
    // -----------------------week start n end date--------------

    let first1 = new Date().getDate() - new Date().getDay();
    let last1 = first1 + 6;
    let ws = new Date(new Date().setDate(first1));
    let weekStartDate = this.pipe.transform(ws, 'yyyy-MM-dd');
    let wl = new Date(new Date().setDate(last1));
    let weekLastDate = this.pipe.transform(wl, 'yyyy-MM-dd');

    // -----------------------month and start n end date--------------
    let monStrt = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    let monthStartDate = this.pipe.transform(monStrt, 'yyyy-MM-dd');
    let monEnd = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    let monthLastDate = this.pipe.transform(monEnd, 'yyyy-MM-dd');
    let yStrt = new Date(new Date().getFullYear(), 0, 1);
    let yearStartDate = this.pipe.transform(yStrt, 'yyyy-MM-dd');
    let yEnd = new Date(new Date().getFullYear(), 11, 31);
    let yearEndDate = this.pipe.transform(yEnd, 'yyyy-MM-dd');
    let lastYearStrt = new Date(new Date().getFullYear() - 1, 0, 1);
    let lastYearStartDate = this.pipe.transform(lastYearStrt, 'yyyy-MM-dd');
    let lastYearEnd = new Date(new Date().getFullYear() - 1, 11, 31);
    let lastYearEndDate = this.pipe.transform(lastYearEnd, 'yyyy-MM-dd');

    this.customFlag = false;
    if (valTime == 'all') {
      this.activeAllFlag = true;
      this.activeYearFlag = false;
      this.activeLastYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewAssistedDashboard.datafor = "all";
      this.viewAssistedDashboard.startdate = "2019-10-01";//yearStartDate;
      this.viewAssistedDashboard.enddate = todayFrmtdDate;
      this.textHeading = "All";
    } else if (valTime == 'year') {
      this.activeAllFlag = false;
      this.activeYearFlag = true;
      this.activeLastYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewAssistedDashboard.datafor = "year";
      this.viewAssistedDashboard.startdate = yearStartDate;
      this.viewAssistedDashboard.enddate = yearEndDate;
      this.textHeading = "This year's";
    } else if (valTime == 'lastYear') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeLastYearFlag = true;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewAssistedDashboard.datafor = "year";
      this.viewAssistedDashboard.startdate = lastYearStartDate;
      this.viewAssistedDashboard.enddate = lastYearEndDate;
      this.textHeading = "Last year's";
    } else if (valTime == 'month') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeLastYearFlag = false;
      this.activeMonthFlag = true;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewAssistedDashboard.datafor = "month";
      this.viewAssistedDashboard.startdate = monthStartDate;
      this.viewAssistedDashboard.enddate = monthLastDate;
      this.textHeading = "This month's";
    } else if (valTime == 'week') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeLastYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = true;
      this.activeTodayFlag = false;
      this.viewAssistedDashboard.datafor = "week";
      this.viewAssistedDashboard.startdate = weekStartDate;
      this.viewAssistedDashboard.enddate = weekLastDate;
      this.textHeading = "This week's";
    } else if (valTime == 'today') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeLastYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = true;
      this.viewAssistedDashboard.datafor = "today";
      this.viewAssistedDashboard.startdate = todayFrmtdDate;
      this.textHeading = "Today's";
    }

     this.getAssistedTxnsDashboardGraphDataView();
     this.getAssistedTxnsDashboardReportView();
     this.getAssistedPaymentKeyperFormanceIndicatorView();
     this.getAssistedTxnsStaticsView();
     this.getAssistedTxnsRegCitizenView();
     this.getAssistedTxnsRegBillerView();
     this.getAssistedTopRecordsView();
     this.getNumberOfVisitor();
     this.getAssistedPaymentSuccessRateViewPi();
     this.getAssistedPaymentTxnsAmountViewPi();
     this.getAssistedPaymentSuccessRateViewPm();
     this.getAssistedPaymentTxnsAmountViewPm();
     this.getAssistedBillerPerformanceView();
     this.getAssistedTransaction();

  }

  isLoaderOff() {
    // this.loaderService.hide();
  }


  //----------------------------------TRANSACTION AND AMOUNT BAR CHART 1-------------------------------------
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;
  isRefresh: boolean = false;
  barChartOptions = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    scales:
      {
        yAxes:
          [
            {
              scaleLabel: {display: true, labelString: 'Number of Transactions', fontSize: 16, fontColor: '#8f3e92'},
              position: 'left', id: '1', type: 'linear',
              ticks: {min: 0, beginAtZero: true, fontSize: 13}
            },
            {
              scaleLabel: {display: true, labelString: 'Total Amount (in BDT)', fontSize: 16, fontColor: '#88c133'},
              position: 'right', id: '2', type: 'linear',
              ticks: {min: 0, beginAtZero: true, fontSize: 13}
            }
          ]
      }
  }; //for skeleton of bars

  public barChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(242,120,161,0.85)',
      borderColor: 'rgb(242,120,161)',
      pointBackgroundColor: 'rgba(242,120,161,0.85)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(242,120,161,0.85)'
    },
    {
      backgroundColor: 'rgba(178,190,234,0.8)',
      borderColor: 'rgb(178,190,234)',
      pointBackgroundColor: 'rgba(178,190,234,0.8)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(178,190,234,0.8)'
    }
  ]; // for the skin of bars

  // sets the total number of transactions and total number of transaction amount
  getNumberOfTransaction(arrayOfTrans: number[], arrayOfAmount: number[]) {

    for (let i = 0; i < arrayOfTrans.length; i++) {
      this.numberOfTrans += arrayOfTrans[i];
    }

    for (let i = 0; i < arrayOfAmount.length; i++) {
      this.transactionAmount += arrayOfAmount[i];
    }
  }


  getAssistedTxnsDashboardGraphDataView() {
    this.isGetTxsnUpdate = false;
    this.isRefresh = false;
    this.viewAssistedTxnsDashboardGraphDataResponse = new ViewAssistedTxnsDashboardGraphDataResponse();
    // this.viewAssistedDashboard.merchantId = 's147';
    this.viewAssistedDashboard.merchantId = this.loginUser.ekpay_id;
    this.serviceAssisted.getAssistedTxnsDashboardGraphDataView(this.viewAssistedDashboard).subscribe((data) => {
      this.isGetTxsnUpdate = true;
      this.isRefresh = true;
      this.viewAssistedTxnsDashboardGraphDataResponse = data.body as ViewAssistedTxnsDashboardGraphDataResponse;
      this.getNumberOfTransaction(this.viewAssistedTxnsDashboardGraphDataResponse.txns, this.viewAssistedTxnsDashboardGraphDataResponse.amount);
      this.barChartData = [ //value for y axis.....the dataset for the barchart
        {
          data: this.viewAssistedTxnsDashboardGraphDataResponse.txns,
          label: 'No. of Transactions',
          yAxisID: '1',
          fill: true,
        },
        {
          data: this.viewAssistedTxnsDashboardGraphDataResponse.amount,
          label: 'Total Amount',
          yAxisID: '2',
          fill: true,
        }
      ]
      this.barChartLabels = this.viewAssistedTxnsDashboardGraphDataResponse.timeperiod;
    })
  }

  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  //----------------------------------STATICS PIE CHART 1 DONE-----------------------------------------
  public pieChartLabels: string[] = ['Total Visitors', 'Bill Fetch', 'Bill Paid', 'Successful Transactions'];
  public pieChartType: string = 'pie';
  public pieChartColors: Array<any> = [
    {
      backgroundColor: ['#0d9b8c', '#ff9900', '#8f3e92', '#7cb62c'],
      borderColor: ['#0d9b8c', '#ff9900', '#8f3e92', '#7cb62c']
    }
  ];


  getAssistedTxnsStaticsView() {
    this.isTxsnStaticsUpdate = false;
    // this.serviceAssisted.getAssistedTxnsStaticsView(this.viewAssistedDashboard).subscribe((data) => {
    //   this.isTxsnStaticsUpdate = true;
    //   this.assistedTxnsStaticsView = data.body as AssistedTxnsStaticsView;
    //   this.pieChartData = [this.assistedTxnsStaticsView.total_visitors, this.assistedTxnsStaticsView.bill_fetch, this.assistedTxnsStaticsView.bill_paid, this.assistedTxnsStaticsView.success_txns];
    // });
  }

  public chartPieClicked(e: any): void {
    console.log(e);
  }

  public chartPieHovered(e: any): void {
    console.log(e);
  }

  //--------------------------------NUMBER OF VISITORS LINE CHART 1------------------------------------------

  public lineChartLegend: boolean = true;
  public lineChartType: string = 'line';
  public lineChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    spanGaps: true,
    fill: false,
    scales:
      {
        xAxes: [{
          maxRotation: 90,
          ticks: {
            autoSkip: false,
          }
        }],
        yAxes:
          [
            {
              scaleLabel: {
                display: true,
                labelString: 'Number of Visitors',
                fontSize: 16,
                fontColor: 'rgba(0,191,165,1)'
              },
              ticks: {min: 0, beginAtZero: true, fontSize: 13}
            }
          ]
      }
  };
  public lineChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(171,234,225,0.5)',
      borderColor: 'rgba(0,191,165,1)',
      pointBackgroundColor: 'rgba(0,191,165,1)',
      pointBorderColor: 'rgba(0,191,165,1)',
      pointHoverBackgroundColor: 'rgba(0,191,165,1)',
      pointHoverBorderColor: 'rgba(0,191,165,1)'
    },
  ];

  getNumberOfVisitor() {
    this.isVisitorUpdate = false;
    this.inputOfVisitors.data_for = this.viewAssistedDashboard.datafor;
    this.inputOfVisitors.start_date = this.viewAssistedDashboard.startdate;
    this.inputOfVisitors.end_date = this.viewAssistedDashboard.enddate;
    this.inputOfVisitors.mode = this.viewAssistedDashboard.mode;

    // this.serviceAssisted.getNumberOfVisitor(this.inputOfVisitors).subscribe((data) => {
    //
    //   this.numberOfVisitors = data.body as NumberOfVisitors;
    //   this.isVisitorUpdate = true;
    //   this.lineChartData = [
    //     {data: this.numberOfVisitors.no_of_visitors, label: 'Number of Visitors'}
    //   ];
    //   this.lineChartLabels = this.numberOfVisitors.date_hour;
    // });
  }

  //--------------------------------------LINE CHART 2--------------------------------------------
  public hollowLineChartType: string = 'bar';       //line
  public hollowChartOptions: any = {
    type: 'bar',        //line
    maintainAspectRatio: false,
    responsive: true,
    fill: true,
    fillColor: '#e91e63',
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }

        }],
        yAxes:
          [
            {
              scaleLabel: {display: true, labelString: 'Transaction Amount', fontSize: 16, fontColor: '#e91e63'},
              ticks: {min: 0, beginAtZero: true, fontSize: 13}
            }
          ]
      }
  }
  public hollowChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(233,30,99,0.5)',
      borderColor: '#e91e63',
      pointBackgroundColor: '#e91e63',
      pointBorderColor: '#e91e63',
      pointHoverBackgroundColor: '#e91e63',
      pointHoverBorderColor: '#e91e63'
    },
  ];


  getAssistedPaymentTxnsAmountViewPi() {
    this.isPITxsnUpdate = false;
    // this.assistedPaymentTxnsAmountView.type = "pi";
    this.assistedPaymentTxnsAmountView.datafor = this.viewAssistedDashboard.datafor;
    this.assistedPaymentTxnsAmountView.startdate = this.viewAssistedDashboard.startdate;
    this.assistedPaymentTxnsAmountView.enddate = this.viewAssistedDashboard.enddate;
    this.assistedPaymentTxnsAmountView.mode = this.viewAssistedDashboard.mode;

    // this.serviceAssisted.getAssistedPaymentTxnsAmountView(this.assistedPaymentTxnsAmountView).subscribe((data) => {
    //   this.isPITxsnUpdate = true;
    //   this.assistedPaymentTxnsAmountViewResp = data.body as AssistedPaymentTxnsAmountViewResp;
    //   this.hollowLineChartData = [
    //     {data: this.assistedPaymentTxnsAmountViewResp.total_amount, label: 'Transaction Amount', fill: false}
    //   ];
    //   this.hollowLineChartLabels = this.assistedPaymentTxnsAmountViewResp.payment_name;
    // });
  }

  public hollowLineClicked(e: any): void {
    console.log(e);
  }

  public hollowLineHovered(e: any): void {
    console.log(e);
  }

  //--------------------------------3Rd LINE CHART-------------------------------------------

  public lineSFChartType: string = 'bar';     //line
  public lineSFChartOptions: any = {
    type: 'bar',          //line
    responsive: true,
    maintainAspectRatio: false,
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }
        }],
        yAxes:
          [
            {
              scaleLabel: {display: true, labelString: 'Rate ( in Percentage )', fontSize: 16, fontColor: '#0d9b8c'},
              ticks: {min: 0, beginAtZero: true, fontSize: 13}
            }
          ]
      }
  };
  public lineSFChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(233,30,99,0.5)',
      borderColor: 'rgba(233,30,99,1)',
      pointBackgroundColor: '#e91e63',
      pointBorderColor: '#e91e63',
      pointHoverBackgroundColor: '#e91e63',
      pointHoverBorderColor: '#e91e63',
    },
    {
      backgroundColor: '#0d9b8c',
      borderColor: '#0d9b8c',
      pointBackgroundColor: '#0d9b8c',
      pointBorderColor: '#0d9b8c',
      pointHoverBackgroundColor: 'rgba(13,155,140,0.4)',
      pointHoverBorderColor: 'rgba(13,155,140,1)'
    },
  ];



  getAssistedPaymentSuccessRateViewPi() {
    this.isPISuccFailUpdate = false;
    this.assistedPaymentTxnsAmountView.startdate = this.viewAssistedDashboard.startdate;
    this.assistedPaymentTxnsAmountView.enddate = this.viewAssistedDashboard.enddate;
    this.assistedPaymentTxnsAmountView.datafor = this.viewAssistedDashboard.datafor;
    this.assistedPaymentTxnsAmountView.mode = this.viewAssistedDashboard.mode;
    // this.assistedPaymentTxnsAmountView.type = "pi";
    // this.serviceAssisted.getAssistedPaymentSuccessRateView(this.assistedPaymentTxnsAmountView).subscribe((data) => {
    //   this.isPISuccFailUpdate = true;
    //   this.assistedPaymentSuccessRateView = data.body as AssistedPaymentSuccessRateView;
    //   this.lineSFChartData = [
    //     {
    //       data: this.assistedPaymentSuccessRateView.success, label: 'Success'
    //     },
    //     {
    //       data: this.assistedPaymentSuccessRateView.fail, label: 'Failure'
    //     }
    //   ]
    //   this.lineSFChartLabels = this.assistedPaymentSuccessRateView.payment_name;
    // });
  }

  //---------------------------------4th LINE CHART-------------------------------

  public LinePIChartType: string = 'bar';
  line
  public ChartPIOptions: any = {
    type: 'bar',        //line
    maintainAspectRatio: false,
    // spanGaps: true,
    responsive: true,
    fill: true,
    fillColor: '7f93dc',
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }
        }],
        yAxes:
          [
            {
              scaleLabel: {display: true, labelString: 'Transaction Amount', fontSize: 16, fontColor: '#7f93dc'},
              ticks: {min: 0, beginAtZero: true, fontSize: 13}
            }
          ]
      }
  }
  public LinePIChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(127,147,220,0.5)',
      borderColor: '#7f93dc',
      pointBackgroundColor: '#7f93dc',
      pointBorderColor: 'white',
      pointHoverBackgroundColor: '#7f93dc',
      pointHoverBorderColor: '#7f93dc'
    },
  ];


  getAssistedPaymentTxnsAmountViewPm() {
    this.isPMTxsnUpdate = false;
    // this.assistedPaymentTxnsAmountView.type = "pm";
    this.assistedPaymentTxnsAmountView.datafor = this.viewAssistedDashboard.datafor;
    this.assistedPaymentTxnsAmountView.startdate = this.viewAssistedDashboard.startdate;
    this.assistedPaymentTxnsAmountView.enddate = this.viewAssistedDashboard.enddate;
    this.assistedPaymentTxnsAmountView.mode = this.viewAssistedDashboard.mode;
    // this.serviceAssisted.getAssistedPaymentTxnsAmountView(this.assistedPaymentTxnsAmountView).subscribe((data) => {
    //   this.isPMTxsnUpdate = true;
    //   this.assistedPaymentTxnsAmountViewResp = data.body as AssistedPaymentTxnsAmountViewResp;
    //   this.LinePIChartData = [
    //     {data: this.assistedPaymentTxnsAmountViewResp.total_amount, label: 'Transaction Amount', fill: false}
    //   ];
    //   this.LinePIChartLabels = this.assistedPaymentTxnsAmountViewResp.payment_name;
    // });
  }

  public LinePIClicked(e: any): void {
    console.log(e);
  }

  public LinePIHovered(e: any): void {
    console.log(e);
  }

  // ---------------------5th LINE CHART-------------------------------

  public linePISFChartType: string = 'bar';       //line
  public linePISFChartOptions: any = {
    type: 'bar',        //line
    responsive: true,
    maintainAspectRatio: false,
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }
        }],
        yAxes:
          [
            {
              scaleLabel: {display: true, labelString: 'Rate ( in Percentage )', fontSize: 16, fontColor: '#ff9900'},
              ticks: {min: 0, beginAtZero: true, fontSize: 13}
            }
          ]
      }
  };
  public linePISFChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(0,191,165,0.5)',
      borderColor: 'rgba(0,191,165,1)',
      pointBackgroundColor: 'rgba(0,191,165,1)',
      pointBorderColor: 'rgba(0,191,165,1)',
      pointHoverBackgroundColor: 'rgba(0,191,165,1)',
      pointHoverBorderColor: 'rgba(0,191,165,1)'
    },
    {
      backgroundColor: 'rgba(255,153,0,1)',
      borderColor: 'rgba(255,153,0,1)',
      pointBackgroundColor: 'rgba(255,153,0,1)',
      pointBorderColor: 'rgba(255,153,0,1)',
      pointHoverBackgroundColor: 'rgba(255,153,0,1)',
      pointHoverBorderColor: 'rgba(255,153,0,1)'
    },
  ];


  getAssistedPaymentSuccessRateViewPm() {
    this.isPMSuccFailUpdate = false;
    this.assistedPaymentTxnsAmountView.startdate = this.viewAssistedDashboard.startdate;
    this.assistedPaymentTxnsAmountView.enddate = this.viewAssistedDashboard.enddate;
    this.assistedPaymentTxnsAmountView.datafor = this.viewAssistedDashboard.datafor;
    this.assistedPaymentTxnsAmountView.mode = this.viewAssistedDashboard.mode;
    // this.assistedPaymentTxnsAmountView.type = "pm";
    this.assistedPaymentTxnsAmountView.merchantId = this.loginUser.ekpay_id;
    this.serviceAssisted.getAssistedPaymentSuccessRateView(this.assistedPaymentTxnsAmountView).subscribe((data) => {
      this.isPMSuccFailUpdate = true;
      this.assistedPaymentSuccessRateView = data.body as AssistedPaymentSuccessRateView;
      this.linePISFChartData = [
        {
          data: this.assistedPaymentSuccessRateView.success, label: 'Success'
        },
        {
          data: this.assistedPaymentSuccessRateView.fail, label: 'Failure'
        }
      ]
      this.linePISFChartLabels = this.assistedPaymentSuccessRateView.payment_name;
    });
  }

  //----------------------------------Biller Performance 2nd BAR CHART-------------------------------
  public barChart2Type: string = 'bar';
  public barChart2Legend: boolean = true;
  public barChart2Options: any = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    scaleShowVerticalLines: false,
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }
        }],
        yAxes:
          [{
            scaleLabel: {
              display: true,
              labelString: 'No. of Transactions',
              fontSize: 15,
              fontColor: 'rgba(136,193,51,1)'
            },
            ticks: {min: 0, beginAtZero: true, fontSize: 13}

          }]
      }
  };

  public assistedChart2Options: any = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: false,
    scaleShowVerticalLines: false,
    scales:
      {
        xAxes: [{
          ticks: {
            maxRotation: 90,
          }
        }],
        yAxes:
          [{
            scaleLabel: {
              display: true,
              labelString: 'Total Amount of Transactions',
              fontSize: 15,
              fontColor: 'rgba(136,193,51,1)'
            },
            ticks: {min: 0, beginAtZero: true, fontSize: 13}

          }]
      }
  };

  public getRandomColor() {
    var letters = '0123456789ABCDEF'.split('');
    for (var i = 0; i < 6; i++) {
      this.color += letters[Math.floor(Math.random() * 16)];
    }
    return this.color;
  }

  public barChart2Colors: Array<any> = [
    {
      backgroundColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)'],
      borderColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)'],
      pointBackgroundColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)'],
      pointBorderColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)'],
      pointHoverBackgroundColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)'],
      pointHoverBorderColor: ['rgba(136,193,51,0.5)', 'rgba(143,62,146,0.5)', 'rgba(127,147,220,0.5)', 'rgba(233,30,99,0.5)', 'rgba(255,153,0,0.5)', 'rgba(0,191,165,0.5)']
    }
  ];

  getAssistedBillerPerformanceView() {
    this.idBillerPerUpdate = false;
    this.viewAssistedDashboard.merchantId = this.loginUser.ekpay_id;
    this.serviceAssisted.getAssistedBillerPerformanceView(this.viewAssistedDashboard).subscribe((data) => {
      this.idBillerPerUpdate = true;
      this.billerPerformance = data.body as BillerPerformance;
      this.barChart2Data =
        [
          {
            data: this.billerPerformance.no_of_txns, label: 'No. of transaction'
          }
        ]
      this.barChart2Labels = this.billerPerformance.blr_name;
      this.isDataRefresh = true;
    });
  }

  getAssistedTransaction() {
    //console.log("assisetd graph called")
    this.isAssistedUpdate = false;
    // this.serviceAssisted.getAssistedPerformanceView(this.assistedPaymentTxnsAmountView).subscribe((data) => {
    //   this.isAssistedUpdate = true;
    //   //console.log("here is the data   ",data);
    //   this.assistedPerformance = data.body as AssistedPerformance;
    //   this.barChartAssistedData =
    //     [
    //       {
    //         data: this.assistedPerformance.total_amount, label: 'Total amount of transaction'
    //       }
    //     ]
    //   this.barChartAssistedLabels = this.assistedPerformance.payment_name;
    //   this.isDataRefresh = true;
    // });
  }             //...............this one

  public chart2Clicked(e: any): void {
    console.log(e);
  }

  public chart2Hovered(e: any): void {
    console.log(e);
  }

  // -------------------------- Tabular registers biller ---------------------------


  getAssistedTxnsDashboardReportView() {
    this.isTxsnReportUpdate = false;
    // this.serviceAssisted.getAssistedTxnsDashboardReportView(this.viewAssistedDashboard).subscribe((data) => {
    //   this.isTxsnReportUpdate = true;
    //   console.log("i am here  ",data);
    //   this.viewAssistedDashboardResponse = data.body as ViewAssistedDashboardResponse;
    // });
  }

  // -------------------Key Performace Indicator------------------------------

  getAssistedPaymentKeyperFormanceIndicatorView() {
    this.isKeyPerUpdate = false;
    // this.serviceAssisted.getAssistedPaymentKeyperFormanceIndicatorView(this.viewAssistedDashboard).subscribe((data) => {
    //   this.isKeyPerUpdate = true;
    //   this.assistedPaymentKeyperFormanceIndicatorView = data.body as AssistedPaymentKeyperFormanceIndicatorView;
    // });
  }

  //----------------------fetch admin txns reg citizen-----------------
  totalCitizenReg: number = 0;
  getAssistedTxnsRegCitizenView() {
    this.isRegCitizenUpdate = false;
    // this.serviceAssisted.getAssistedTxnsRegCitizenView(this.viewAssistedDashboard).subscribe((data) => {
    //   this.isRegCitizenUpdate = true;
    //   this.totalCitizenReg = data.body.reg_citizen;
    // });
  }

  // ---------------------EkPay Registered Billers-----------------------
  getAssistedTxnsRegBillerView() {
    this.isRecentTransaction = false;
    this.isRegBillerUpdate = false;
    this.viewAssistedDashboard.merchantId = this.loginUser.ekpay_id;
    this.serviceAssisted.getAssistedTxnsRegBillerView(this.viewAssistedDashboard).subscribe((data) => {
      this.isRegBillerUpdate = true;
      this.assistedTxnsRegBillerView = data.body as AssistedTxnsRegBillerView;
      if (this.assistedTxnsRegBillerView.registered_billers == null) {
        this.isRecentTransaction = true;
      }
    });
  }

  // --------------------------fetch admin top records------------------

  getAssistedTopRecordsView() {
    let topBiller = new TopBiller();
    this.isTopRecordUpdate = false;
    this.isTopBillerAvail = false;
    topBiller.datafor = this.viewAssistedDashboard.datafor;
    topBiller.startdate = this.viewAssistedDashboard.startdate;
    topBiller.enddate = this.viewAssistedDashboard.enddate;
    topBiller.mode = this.viewAssistedDashboard.mode;
    topBiller.recordfor = "biller";
    // this.serviceAssisted.getAssistedTopRecordsView(topBiller).subscribe((data) => {
    //   this.isTopRecordUpdate = true;
    //   this.loaderOff = 1;
    //   if (this.loaderOff == 1) {
    //     this.isLoaderOff();
    //   }
    //   this.topBillerResp = data.body as TopBillerResp;
    //   if (this.topBillerResp.top_records.length == 0) {
    //     this.isTopBillerAvail = true;
    //   }
    // });
  }

  viewUser() {
    this.router.navigate(['/user/view']);
  }

  viewBiller() {
    this.router.navigate(['/biller/views']);
  }

  onCustom() {
    this.customFlag = true;
    this.activeAllFlag = false;
    this.activeYearFlag = false;
    this.activeMonthFlag = false;
    this.activeWeekFlag = false;
    this.activeTodayFlag = false;
    this.activeLastYearFlag = false;
  }

  chartSFHovered($event: any) {
    console.log($event);
  }

  chartSFClicked($event: any) {
    console.log($event);
  }

  chartPISFHovered($event: any) {
    console.log($event);
  }

  chartPISFClicked($event: any) {
    console.log($event);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboards/assisted-dashboard/assisted-dashboard.component.ts